var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projects_Donation_History",
    "data-name": "Projects Donation History",
    transform: "translate(-41.1 -41.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10195",
    "data-name": "Path 10195",
    d: "M10.1,12.113v4.5a3.519,3.519,0,0,0,1.706,2.831,10.642,10.642,0,0,0,5.89,1.559,10.642,10.642,0,0,0,5.89-1.559,3.519,3.519,0,0,0,1.706-2.831v-4.5a.991.991,0,1,0-1.982,0v4.5c0,.451-.357.82-.842,1.157A8.657,8.657,0,0,1,17.7,18.98a8.657,8.657,0,0,1-4.772-1.207c-.486-.338-.842-.706-.842-1.157v-4.5a.991.991,0,1,0-1.982,0Z",
    transform: "translate(39.807 39.591)",
    fill: "#444",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10196",
    "data-name": "Path 10196",
    d: "M10.1,16.113v4.5a3.519,3.519,0,0,0,1.706,2.831,10.642,10.642,0,0,0,5.89,1.559,10.642,10.642,0,0,0,5.89-1.559,3.519,3.519,0,0,0,1.706-2.831v-4.5a.991.991,0,1,0-1.982,0v4.5c0,.451-.357.82-.842,1.157A8.657,8.657,0,0,1,17.7,22.98a8.657,8.657,0,0,1-4.772-1.207c-.486-.338-.842-.706-.842-1.157v-4.5a.991.991,0,1,0-1.982,0Z",
    transform: "translate(39.807 40.094)",
    fill: "#444",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10197",
    "data-name": "Path 10197",
    d: "M17.7,8.1a10.64,10.64,0,0,0-5.889,1.559A3.52,3.52,0,0,0,10.1,12.49a3.52,3.52,0,0,0,1.708,2.831A10.64,10.64,0,0,0,17.7,16.88a10.64,10.64,0,0,0,5.889-1.559,3.52,3.52,0,0,0,1.708-2.831,3.52,3.52,0,0,0-1.708-2.831A10.64,10.64,0,0,0,17.7,8.1Zm0,2.026a8.671,8.671,0,0,1,4.772,1.207c.486.339.842.706.842,1.157s-.357.818-.842,1.157A8.671,8.671,0,0,1,17.7,14.854a8.671,8.671,0,0,1-4.772-1.207c-.486-.339-.842-.706-.842-1.157s.357-.818.842-1.157A8.671,8.671,0,0,1,17.7,10.126Z",
    transform: "translate(39.807 39.214)",
    fill: "#444",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10198",
    "data-name": "Path 10198",
    d: "M10.1,12.113v4.5a3.231,3.231,0,0,0,1.131,2.367A8.212,8.212,0,0,0,15.3,20.8a.994.994,0,0,0,1.149-.82,1.012,1.012,0,0,0-.8-1.175,7,7,0,0,1-2.759-1.05c-.468-.332-.81-.693-.81-1.135v-4.5a.991.991,0,1,0-1.982,0Z",
    transform: "translate(31 33.377)",
    fill: "#444",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10199",
    "data-name": "Path 10199",
    d: "M10.1,16.993v4.5a3.375,3.375,0,0,0,1.42,2.617,9.507,9.507,0,0,0,5,1.723,1.013,1.013,0,0,0,.165-2.02,7.532,7.532,0,0,1-3.943-1.3,1.4,1.4,0,0,1-.657-1.02v-4.5a.991.991,0,1,0-1.982,0Zm6.569-2.183a7.523,7.523,0,0,1-3.931-1.3,1.4,1.4,0,0,1-.656-1.018c0-.451.357-.818.842-1.157A8.671,8.671,0,0,1,17.7,10.126a8.671,8.671,0,0,1,4.772,1.207c.486.339.842.706.842,1.157a.991.991,0,1,0,1.982,0,3.52,3.52,0,0,0-1.708-2.831A10.64,10.64,0,0,0,17.7,8.1a10.64,10.64,0,0,0-5.889,1.559A3.52,3.52,0,0,0,10.1,12.49,3.371,3.371,0,0,0,11.517,15.1,9.5,9.5,0,0,0,16.5,16.829a1.013,1.013,0,0,0,.167-2.018Z",
    transform: "translate(31 33)",
    fill: "#444",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsIcon);
export default __webpack_public_path__ + "static/media/coinsIcon.3e718853d8b45479a7490e38b7ad0488.svg";
export { ForwardRef as ReactComponent };